import React, { useEffect, useState } from "react";
import Table from "../../../Utils/Table/Table1";
import { fDateTimesec } from "../../../Utils/Date_format/datefromat";
import { getlogoutuser, GetUsersName } from "../../../Services/Admin/Addmin";
import { getUserFromToken } from "../../../Utils/TokenVerify";

const Loginstatus = () => {
  const TokenData = getUserFromToken();

  const user_id = TokenData?.user_id;

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [users, setUsers] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loginStatusFilter, setLoginStatusFilter] = useState("");
 const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchUsers = async () => {
    try {
      const response = await GetUsersName({ admin_id: user_id });
      if (response && response.data && response.data.length > 0) {
        setUsers(response.data);
      } else {
        setUsers([]);
      }
    } catch (error) {
      setUsers([]);
    }
  };

  const getLogsForSelectedUser = async () => {
    try {
      const data = { userid: user_id,
      loginStatus: loginStatusFilter,
 userId: selectedUserId,
   page,
  limit: rowsPerPage,
  search, };

      const response = await getlogoutuser(data);

      if (response.status) {
     setData(response.data);
setTotalPages(response.pagination.totalPages);
      }
    
    } catch (error) { }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    getLogsForSelectedUser();
  }, [selectedUserId, search, loginStatusFilter, page, rowsPerPage,loginStatusFilter]);


   const handlePageChange = (newPage) => {
  if (newPage < 1) return;
  setPage(newPage);
};

const handleRowsPerPageChange = (newLimit) => {
  setRowsPerPage(newLimit);
  setPage(1); // reset page when limit changes
};



  // const columns = [
  //   { Header: "UserName", accessor: "UserName" },
  //   { Header: "Role", accessor: "role" },
  //   { Header: "Created By", accessor: "parent_role" },

  //   {
  //     Header: "Login Status",
  //     accessor: "login_status",
  //     Cell: ({ cell }) => (
  //       <span style={{ color: cell.value === "Panel On" ? "green" : "red" }}>
  //         {cell.value}
  //       </span>
  //     ),
  //   },
  //   {
  //     Header: "Create Date",
  //     accessor: "createdAt",
  //     Cell: ({ cell }) => {
  //       return fDateTimesec(cell.value);
  //     },
  //   },
  // ];
const columns = [
   {
  Header: "S.No",
  id: "rowIndex",
  Cell: ({ row, index }) => {
    return (page - 1) * rowsPerPage + (index + 1);
  }
},
  { Header: "UserName", accessor: "UserName" },

  { Header: "Role", accessor: "role" },

  { Header: "Created By", accessor: "parent_role" },

  {
    Header: "Login Status",
    accessor: "login_status",
    Cell: ({ row }) => (
      <span style={{ color: row.login_status === "Panel On" ? "green" : "red" }}>
        {row.login_status}
      </span>
    ),
  },

  {
    Header: "Create Date",
    accessor: "createdAt",
    Cell: ({ row }) => {
      return row.createdAt ? fDateTimesec(row.createdAt) : "-";
    },
  },
];


  return (
    <div>
      <div className="container-fluid mt-5">
        <div className="row">
          <div className="col-lg-12">
            <div className="card transaction-table custom-bg">
              <div className="card-header border-0 flex-wrap ">
                <div className="mb-2 ">
                  <h4 className="card-title">Login Status</h4>
                </div>
              </div>
              <div className="card-body p-0">
                <div className="tab-content" id="myTabContent1">
                  {/* <div className="row mb-3 ms-3">
                    <div className="col-md-3">
                      <div className="">
                        <label className="me-2">Search:</label>
                        <input
                          className="form-control"
                          style={{ width: "75%" }}
                          type="text"
                          placeholder="Search..."
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="">
                        <label className="me-2">Select User:</label>
                        <select
                          className="form-control"
                          style={{ width: "50%%" }}
                          onChange={(e) => setSelectedUserId(e.target.value)}
                          value={selectedUserId}
                        >
                          <option value="">Select a user</option>
                          {users.length > 0 ? (
                            users.map((user) => (
                              <option key={user.id} value={user.id}>
                                {user?.UserName}
                              </option>
                            ))
                          ) : (
                            <option>No users available</option>
                          )}
                        </select>

                      </div>

                    </div>

                    <div className="col-md-3">
                      <label className="me-2">Login Status:</label>
                      <select
                        className="form-control"
                        style={{ width: "60%" }}
                        onChange={(e) => setLoginStatusFilter(e.target.value)}
                        value={loginStatusFilter}
                      >
                        <option value="">All</option>
                        <option value="Panel On">Panel On</option>
                        <option value="Panel off">Panel Off</option>
                      </select>
                    </div>

                  </div> */}
                  <div className="row mb-3 ms-3 me-3 d-flex align-items-end">

  {/* SEARCH */}
  <div className="col-md-4 mt-4">
    <label className="fw-bold mb-1">🔍 Search:</label>
    <input
      type="text"
      className="form-control"
      placeholder="Search..."
      style={{ height: "40px" }}
      value={search}
      onChange={(e) =>{
         setSearch(e.target.value)
        setPage(1)
        }}
    />
  </div>

  {/* SELECT USER */}
  <div className="col-md-4">
    <label className="fw-bold mb-1">Select User:</label>
    <select
      className="form-control"
      style={{ height: "40px" }}
      onChange={(e) => setSelectedUserId(e.target.value)}
      value={selectedUserId}
    >
      <option value="">Select a user</option>
      {users.length > 0 ? (
        users.map((user) => (
          <option key={user._id} value={user._id}>
            {user.UserName}
          </option>
        ))
      ) : (
        <option>No users available</option>
      )}
    </select>
  </div>

  {/* LOGIN STATUS */}
  <div className="col-md-4">
    <label className="fw-bold mb-1">Login Status:</label>
    <select
      className="form-control"
      style={{ height: "40px" }}
      onChange={(e) => setLoginStatusFilter(e.target.value)}
      value={loginStatusFilter}
    >
      <option value="">All</option>
      <option value="Panel On">Panel On</option>
      <option value="Panel Off">Panel Off</option>
    </select>
  </div>

</div>


                  <div
                    className="tab-pane fade show active"
                    id="Week"
                    role="tabpanel"
                    aria-labelledby="Week-tab"
                  >
                    <Table
                      columns={columns}
                      data={data}
                      page={page}
                      totalPages={totalPages}
                      initialRowsPerPage={rowsPerPage}
                      onPageChange={handlePageChange}
                      onRowsPerPageChange={handleRowsPerPageChange}
                    />

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loginstatus;
